//Paquetes NPM de GYF.
import { Mediator } from 'com-gyf-webcore-mediator';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy, SagasHelper } from 'com-gyf-webcore-servicehub';

//Import del reducer de DistribucionLimites.
import distribucionLimitesReducer from '../../../store/Reducers/DistribucionLimites'

import SolicitudManager from '../../../Common/Managers/SolicitudManager';
import ProcessManager from '../../../Common/Managers/ProcessManager';
//Seteo de apiUrl
RestApiProxy.SetApiUrl();
export const GET_ENTERPRISE_BY_CUIT = 'GET_ENTERPRISE_BY_CUIT';
export const GET_ENTERPRISE_BY_CUIT_RESULT = 'GET_ENTERPRISE_BY_CUIT_RESULT';
export const GET_DATA_ENTERPRISE = 'GET_DATA_ENTERPRISE';
export const SELECCIONAR_EMPRESA = 'SELECCIONAR_EMPRESA';
export const SHOW_ERROR_SOLICITUD_EMPRESA = 'SHOW_ERROR_SOLICITUD_EMPRESA';
export const GET_DATA_ENTERPRISE_RESULT = 'GET_DATA_ENTERPRISE_RESULT';
export const GUARDAR_SOLICITUD_BORRADOR_NUEVA_SOLICITUD_EMPRESA = 'GUARDAR_SOLICITUD_BORRADOR_NUEVA_SOLICITUD_EMPRESA';
export const FUNCTION_CODE_CREATE = 'Alta';
export const FUNCTION_CODE_QUERY = 'Consulta';
export const FUNCTION_CODE_CONFIRMATION = 'Confirmacion';
export const FUNCTION_CODE_DISTRIBUTION = 'Distribucion';
export const FUNCTION_CODE_EDIT = "Modificacion";
export const FUNCTION_CODE_CONFIDENTIAL = 'Confidencial';
export const SHOW_SAVE_STATUS_NUEVA_SOLICITUD_EMPRESA = 'SHOW_SAVE_STATUS_NUEVA_SOLICITUD_EMPRESA';
export const SAVE_REQUEST = 'SAVE_REQUEST';
export const GET_ROUTTING_STATE = 'GET_ROUTTING_STATE';
export const OPEN_MODAL_DISTRIBUIRLIMITES_EMPRESA = 'OPEN_MODAL_DISTRIBUIRLIMITES_EMPRESA';
export const CLOSE_MODAL_DISTRIBUIRLIMITES_EMPRESA = 'CLOSE_MODAL_DISTRIBUIRLIMITES_EMPRESA';
export const ACTUALIZAR_LIMITES_EMPRESA = 'ACTUALIZAR_LIMITES_EMPRESA';
export const OPEN_MODAL_INFORMACION_EMPRESA = 'OPEN_MODAL_INFORMACION_EMPRESA';
export const CLOSE_MODAL_INFORMACION_EMPRESA = 'CLOSE_MODAL_INFORMACION_EMPRESA';
export const ROUTE_TO_CUENTA_FROM_EMPRESA = 'ROUTE_TO_CUENTA_FROM_EMPRESA';
export const ACTUALIZAR_ESTADO_GLOBAL_EMPRESA = 'ACTUALIZAR_ESTADO_GLOBAL_EMPRESA';
export const RESET_STATE_SOLICITUD_EMPRESA = 'RESET_STATE_SOLICITUD_EMPRESA';
export const ROUTE_TO_VISTACLIENTE_FROM_EMPRESA = "ROUTE_TO_VISTACLIENTE_FROM_EMPRESA";
export const ACTUALIZAR_ESTADO_DISTRIBUCION_EMPRESA = 'ACTUALIZAR_ESTADO_DISTRIBUCION_EMPRESA';
export const ELIMINAR_FUTURO_FROM_EMPRESA = 'ELIMINAR_FUTURO_FROM_EMPRESA';
export const MOSTRAR_MENSAJE_GUARDAR_BORRADOR = 'MOSTRAR_MENSAJE_GUARDAR_BORRADOR';
export const EMPRESA_SELECCIONADA = 'EMPRESA_SELECCIONADA';

let _dispatch, _routingState, _tarjetas = null;
let userFeatures = [];

/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} state
 * @param {any} currentScope
 * @param {any} datosSolicitud
 */
export function getScreenData(currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        const state = getState();

        _tarjetas = JSON.parse(JSON.stringify(state.tarjetas));

        dispatch({ type: GET_ENTERPRISE_BY_CUIT, state });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _cargaInicialResultado(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/**
 * Reset del state de la pantalla.
 */
export function resetStateSolicitudEmpresa() {
    LogHelper.In(resetStateSolicitudEmpresa.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: RESET_STATE_SOLICITUD_EMPRESA });
    }
}

/**
 * 
 * @param {any} id
 */
export function getDataEnterprise(id) {
    LogHelper.In(getDataEnterprise.name, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        _getDataEnterprise(id);
    }
}

/**
 * 
 * @param {any} id
 */
export function saveRequest(id) {
    LogHelper.In(saveRequest.name, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: SAVE_REQUEST,
            id: id
        });
    }
}

/**
 * 
 * @param {any} id
 */
export function seleccionarEmpresa(id) {
    LogHelper.In(seleccionarEmpresa.name, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        const state = getState();
        let empresaSeleccionada = state.tarjetas.empresas.filter(empresa=>empresa.Id == id)[0];
        
        //Elimino el futuro si hay una cuenta nueva y se selecciona una nueva empresa.
        if (state.tarjetas.cuentas != undefined || state.tarjetas.tarjetas != undefined) {
            if (state.tarjetas.cuentas.find(x => x.esNueva == true && x.EmpresaId != id) != undefined || state.tarjetas.cuentas.find(x => x.seleccionada == true && x.EmpresaId != id) != undefined && state.tarjetas.tarjetas.find(x => x.esNueva == true) != undefined) {
                dispatch({ type: ELIMINAR_FUTURO_FROM_EMPRESA });
            }
        }
        dispatch({ type: EMPRESA_SELECCIONADA, payload: empresaSeleccionada })

        dispatch({
            type: SELECCIONAR_EMPRESA,
            id: id
        });
    }
}

/**
 * 
 */
export function showError() {
    LogHelper.In(showError.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: SHOW_ERROR_SOLICITUD_EMPRESA
        });
    }
}

/**
 * Actualiza los limites de la pantalla que invoca a la misma.
 * @param {any} estado
 */
export function actualizarLimites(estado) {
    LogHelper.In(actualizarLimites.name, estado);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: ACTUALIZAR_LIMITES_EMPRESA,
            estado: estado
        });
    }
}

/**
 * 
 */
export function routeToNuevaSolicitudCuenta() {
    LogHelper.In(routeToNuevaSolicitudCuenta.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: ACTUALIZAR_ESTADO_GLOBAL_EMPRESA,
            empresas: getState().nuevaSolicitudEmpresa.empresas
        });

        dispatch({
            type: ROUTE_TO_CUENTA_FROM_EMPRESA
        });
    }
}

/**
 * 
 */
export function routeToPrevious() {
    LogHelper.In(routeToPrevious.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: ROUTE_TO_TIPO_EMPRESA
        });
    }
}

/**
 * 
 */
export function routeToCancel() {
    LogHelper.In(routeToCancel.name);
    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: ROUTE_TO_CANCEL
        });
    }
}

/**
 * 
 */
export function routeToLimits() {
    LogHelper.In(routeToLimits.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: ROUTE_TO_LIMITES
        });
    }
}

/**
 * 
 */
export function routeToNewEnterprise() {
    LogHelper.In(routeToNewEnterprise.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: ROUTE_TO_NUEVA_EMPRESA
        });
    }
}

/**
 *
 * @param {any} solicitud
 */
export function guardarSolicitudBorrador() {
    LogHelper.In(guardarSolicitudBorrador.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        if (_tarjetas.empresas.find(x => x.seleccionada) == undefined) {

            dispatch({ type: MOSTRAR_MENSAJE_GUARDAR_BORRADOR });
            return;
        }

        //TODO: MAL, ESTA SETEANDO Y PUEDE HABER INCONSISTENCIA.
        dispatch({ type: ACTUALIZAR_ESTADO_GLOBAL_EMPRESA, empresas: getState().nuevaSolicitudEmpresa.empresas });

        SolicitudManager.GuardarSolicitudBorrador(_tarjetas, (data) => guardarSolicitudBorradorCallback(data, dispatch));
    }
}

/**
 *
 * @param {any} id
 */
export function editNewEnterprise(id) {
    LogHelper.In(editNewEnterprise.name, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: EDIT_TO_NUEVA_EMPRESA,
            id: id
        });
    }
}

/**
 * Abre el modal de distribuir limites.
 */
export function openModalDistribucionLimites() {
    LogHelper.In(openModalDistribucionLimites.name);

    return (dispatch) => {
        _dispatch = dispatch;

        //Inyecto el reducer de distribucionLimites.
        const reducers = [];
        reducers.push(distribucionLimitesReducer);
        dispatch({ type: 'STORE_INJECT', reducers: reducers });

        dispatch({
            type: OPEN_MODAL_DISTRIBUIRLIMITES_EMPRESA
        });
    }
}

/**
 * Cierra el modal de distribuir limites.
 */
export function closeModalDistribucionLimites() {
    LogHelper.In(closeModalDistribucionLimites.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: CLOSE_MODAL_DISTRIBUIRLIMITES_EMPRESA });
    }
}

/**
 * Abre el modal de información de empresas.
 */
export function openModalInformacionEmpresa(id) {
    LogHelper.In(openModalInformacionEmpresa.name, id);

    return (dispatch) => {
        _dispatch = dispatch;
        getDataEnterprise(id);
    }
}

/**
 * Cierra el modal de información de empresas.
 */
export function closeModalInformacionEmpresa() {
    LogHelper.In(closeModalInformacionEmpresa.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: CLOSE_MODAL_INFORMACION_EMPRESA });
    }
}

export function closeModal() {
    $('.modal').modal('hide');
}

/*---------------------------FUNCIONES AUXILIARES----------------------------**/

function guardarSolicitudBorradorCallback(data, dispatch) {
    LogHelper.In(guardarSolicitudBorradorCallback.name, data, dispatch);

    dispatch({ type: ROUTE_TO_VISTACLIENTE_FROM_EMPRESA });
}

function ejecutarPorEstado(result) {
    LogHelper.In(ejecutarPorEstado.name, result);

    let type;
    let modalId;
    //ESTADO Descripcion
    //1	     Iniciada
    //2	     Completada
    //3	     Error
    //4	     CompletadaConDependencias
    //5	     CompletadaErrores
    //6	     Abortada
    //7	     EnCancelacion
    switch (result.Estado) {
        case 2:
            modalId = "completada";
            break;
        case 3:
            modalId = "error";
            break;
        case 4:
            modalId = "completadaConDependencias";
            break;
        case 5:
            modalId = "error";
            break;
    }
    $("#" + modalId).modal();
    _dispatch({ type: SHOW_SAVE_STATUS_NUEVA_SOLICITUD_EMPRESA, sagaId: result.SagaId, modalId: modalId });
}

/**
 * 
 * @param {any} params
 * @param {any} option
 */
function routting(params, option) {
    LogHelper.In(routting.name, params, option);

    params = JSON.stringify(params);

    Mediator.SetEngine1Proxy(Engine1Proxy);
    Mediator.GetNextStep("NewRequestEnterprise", option, params, 'Tarjetas', 'SOLICITUD');
}

/**
 * 
 * @param {any} id
 */
function _getDataEnterprise(id) {
    LogHelper.In(_getDataEnterprise.name, id);

    let param = {
        'EMPRESA_ID': parseInt(id)
    }

    LogHelper.Out(_getDataEnterprise.name, param, 'GET_RUBROS_BY_EMPRESA_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(param, 'GET_RUBROS_BY_EMPRESA_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');

    Engine1Proxy.Execute((data) => getEnterpriceRubros(data, id), null, null, "SOLICITUD");
}

/**
 * 
 * @param {any} data
 */
function getEnterpriceRubros(data, id) {
    LogHelper.In(getEnterpriceRubros.name, data, id);

    let rubros = JSON.parse(data.GET_RUBROS_BY_EMPRESA_ID).Recordset0.Rows[0];

    let resultado = [];
    if (rubros != undefined) {
        addRubro(resultado, rubros.RUBRO1);
        addRubro(resultado, rubros.RUBRO2);
        addRubro(resultado, rubros.RUBRO3);
        addRubro(resultado, rubros.RUBRO4);
        addRubro(resultado, rubros.RUBRO5);
        addRubro(resultado, rubros.RUBRO6);
        addRubro(resultado, rubros.RUBRO7);
        addRubro(resultado, rubros.RUBRO8);
        addRubro(resultado, rubros.RUBRO9);
    }

    _dispatch({
        type: OPEN_MODAL_INFORMACION_EMPRESA,
        idEmpresa: id,
        rubros: resultado
    });
}

function addRubro(resultado, rubro) {
    if (rubro != null) {
        resultado.push({ "Descripcion": rubro });
    }
}

/**
 * 
 * @param {any} data
 */
function _cargaInicialResultado(data) {
    LogHelper.In(_cargaInicialResultado.name, data);

    userFeatures = JSON.parse(JSON.stringify(data));

    let adminEmpCueTarFunctions = JSON.parse(JSON.stringify(data.ADMINEMPCUETAR));
    let adminEmpCueTarFunctionsAllowed = [];

    let solicitudFunctions = JSON.parse(JSON.stringify(data.SOLICITUD));
    let solicitudFunctionsAllowed = [];

    let permissions = {
        components: {
            Pantalla: { Active: false, Locked: false },
            RadioButtons: { Active: false, Locked: false },
            BotonesAnteriorSiguiente: { Active: false, Locked: false },
            BotonNuevaEmpresa: { Active: false, Locked: false },
            BotonDistribuirLimites: { Active: false, Locked: false },
            IconoDeOjo: { Active: false, Locked: false },
            BotonGuardarBorrador: { Active: false, Locked: false }
        },
        adminEmpCueTarFunctionsAllowed: {},
        solicitudFunctionsAllowed: {}
    };

    adminEmpCueTarFunctions.forEach(p => { permissions.adminEmpCueTarFunctionsAllowed[p.Codigo_Funcion] = true; });
    solicitudFunctions.forEach(p => { permissions.solicitudFunctionsAllowed[p.Codigo_Funcion] = true; });

    
    if (permissions.adminEmpCueTarFunctionsAllowed.Alta == true) {
        permissions.components.Pantalla.Active = true;
        permissions.components.RadioButtons.Active = true;
        permissions.components.BotonNuevaEmpresa.Active = true;
        permissions.components.BotonGuardarBorrador.Active = true;

        if (permissions.adminEmpCueTarFunctionsAllowed.Consulta == true) {
            permissions.components.BotonesAnteriorSiguiente.Active = true;
            permissions.components.IconoDeOjo.Active = true;
        }
        if (permissions.solicitudFunctionsAllowed.Distribucion == true) {
            permissions.components.BotonDistribuirLimites.Active = true;
        }
    } else {
        /*Si no tiene permisos sobre la consulta, no es necesario que valide las demas funciones, ya que no
        será capaz de acceder a la pantalla*/
        permissions.components.Pantalla.Active = false;
    }
    

    /*Si tiene permisos sobre la pantalla, continuo con el resto de la carga*/
    if (permissions.components.Pantalla.Active == true) {
        let param;
        if (_tarjetas.clienteResultadoBusqueda.Cuit.toString().indexOf('-') > -1) {
            param = { 'CUIT': parseInt(_tarjetas.clienteResultadoBusqueda.Cuit.split('-').join('')) }
        } else {
            param = { 'CUIT': parseInt(_tarjetas.clienteResultadoBusqueda.Cuit) }
        }
        let IdAdministrator = {
            'ADMINISTRADORA_ID': parseInt(_tarjetas.administradora.Id)
        }
        let parametrosCategoriaIva= {
            'CATEGORIA_IVA_ID': 1 /*_tarjetas.cliente.CategoriaIVA.Id*///MOCKEADO, CAMBIAR AL OBTENER WS ********************************************  
        };

        LogHelper.Out(_cargaInicialResultado.name, IdAdministrator, 'GET_CARTERAS', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(IdAdministrator, 'GET_CARTERAS', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        LogHelper.Out(_cargaInicialResultado.name, parametrosCategoriaIva, 'GET_CATEGORIA_IVA_BY_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parametrosCategoriaIva, 'GET_CATEGORIA_IVA_BY_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        Engine1Proxy.Execute(_loadNuevaSolicitudEmpresaInitialStateData, null, permissions, "PARAMETRIA");
    } else {
        let resultado = {
            'permissions': permissions,
            'showError': false
        }
        _dispatch({ type: ACTUALIZAR_ESTADO_DISTRIBUCION_EMPRESA });
        _dispatch({ type: GET_ENTERPRISE_BY_CUIT_RESULT, resultado: resultado });
    }
}

/**
 * 
 * @param {any} data
 */
function _loadNuevaSolicitudEmpresaInitialStateData(data) {
    LogHelper.In(_loadNuevaSolicitudEmpresaInitialStateData.name, data);

    let resultado = {
        'empresaCuit': _tarjetas.empresas,
        'carteras': JSON.parse(data.GET_CARTERAS).Recordset0.Rows,
        'novedades': _tarjetas.novedadesEmpresas,
        'showError': false,
        'permissions': data.CALLER_ID,
        'atlasCategoriaIva': JSON.parse(data.GET_CATEGORIA_IVA_BY_ID).Recordset0.Rows[0]
    }
    _dispatch({ type: ACTUALIZAR_ESTADO_DISTRIBUCION_EMPRESA });
    _dispatch({ type: GET_ENTERPRISE_BY_CUIT_RESULT, resultado: resultado });
}